export const onChange = (fn) => ({ target: { value } }) => fn(value);

export const saveSession = (name, data) => window.sessionStorage.setItem([name], data);

export const pushGoogleTag = (data) => {
    window.dataLayer.push(data);
};

export const checAuth = (data, setAuth) => {
    if (data.registration_source === 'email') {
        return setAuth({ account: 'email', data: data });
    }
    if (data.registration_source === 'facebook') {
        return setAuth({ account: 'facebook', data: data });
    }
    if (data.registration_source === 'google') {
        return setAuth({ account: 'google', data: data });
    }
};

export const toParam = (obj) => {
    const keys = Object.keys(obj);

    const str = keys.reduce((acc, item) => {
        return acc + item + '=' + obj[item] + '&';
    }, '?');

    return str;
};

export const PLANS = [
    {
        plan: '1-year-plan-apr',
        title: '3 Days Free Trial',
        description: 'Then 12 months of GeoZilla Premium for 47.99 USD',
        form: 'You won’t be charged until the Free Trial Period ends',
        payBtn: 'Start Free Trial',
        cost: 47.99,
        footer: 'Your 3-day free trial starts after you enter payment details, and you will have unlimited access to GeoZilla family safety features. You may cancel at any time during your free trial and will not be charged. To cancel, please write us at support@geozilla.com. GeoZilla will automatically continue your subscription at the end of your free trial and charge 47.99 USD to your payment method on an annual basis until you cancel.'
    },
    {
        plan: '1-month-plan-apr',
        title: 'GeoZilla Premium',
        description: '1 month for 14.99 USD billed monthly',
        form: '',
        payBtn: 'Subscribe',
        cost: 14.99,
        footer: 'Your subscription starts after you enter payment details, and you will have unlimited access to GeoZilla family safety features. To cancel, please write us at support@geozilla.com. GeoZilla will automatically continue your subscription at the end of your subscription period and charge 14.99 USD to your payment method on monthly basis until you cancel.'
    },
];


export const getPlanSubscribe = () => {
    const plan = PLANS.find(i => window.location.search.includes(i.plan));
    if (plan) {
        return plan;
    }

    return PLANS[0];
};